import axios from '../axios-init';

export const getInboundList = params => {
    let list = [{
        id:"1",
        offer:"product1",
        quantity:"100",
        createDate:"2019-07-20 12:00:00"
    },{
        id:"1",
        offer:"product2",
        quantity:"150",
        createDate:"2019-07-20 12:00:00"
    }];
    return Promise.resolve(list);
};

export const getProductInboundList = params => {
    return axios.post(`/inbound/getDetailByProductNo`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const getInboundDetailList = params => {
    return axios.post(`/inbound/getOfferDetail`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const getCancelInboundList = params => {
    return axios.post(`/inbound/getInboundCancelInfoByDoctorId`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const getInboundHistoryList = params => {
    return axios.post(`/inbound/getHistoryInboundData`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const getUnClaimTracking = params => {
    return axios.post(`/inbound/getUnClaimTracking`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const getInboundDetail = params => {
    return axios.post(`/inbound/getInBoundById`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const getNurseConfirmList = params => {
    return axios.post(`/inbound/getInboundListByStatus`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const confirmNurseInbound = params => {
    return axios.post(`/inbound/nurseAddStock`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const cancelNurseInbound = params => {
    return axios.post(`/inbound/cancelInboundById`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const cancelInboundByDoctor = params => {
    return axios.post(`/inbound/cancelInboundByDoctor`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const getBatchNumber = params => {
    return axios.post(`/inbound/getBatchNumber`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const getTrackingList = params => {
    return axios.post(`/confirmWarehouse/getNoMatchData`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getDoctorTrackingList = params => {
    return axios.post(`/confirmWarehouse/getTrackingListForDoctor`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getTrackingConfirmList = params => {
    return axios.post(`/confirmWarehouse/getComfiringDataAndProductList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const importTracking = params => {
    return axios.post(`/confirmWarehouse/saveImportData`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const removeTracking = params => {
    return axios.post(`/confirmWarehouse/removeById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getTrackingById = params => {
    return axios.post(`/confirmWarehouse/getDetailById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const editTrackingById = params => {
    return axios.post(`/confirmWarehouse/editById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getBatchNumberList = params => {
    return axios.post(`/confirmWarehouse/getBatchNumberByType`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const bulkRemove = params => {
    return axios.post(`/confirmWarehouse/batchBulkRemoveByBatchNumber`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getBulkConfirmListByBatchNum = params => {
    return axios.post(`/confirmWarehouse/getComfiringDataAndProductList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const bulkConfirm = params => {
    return axios.post(`/confirmWarehouse/batchBulkComfirmed`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const reverseById = params => {
    return axios.post(`/confirmWarehouse/reverseByCwId`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const bulkReverse = params => {
    return axios.post(`/confirmWarehouse/reverseByBatchNumber`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const editInboundTracking = params => {
    return axios.post(`/confirmWarehouse/editTracking`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const claimTracking = params => {
    return axios.post(`/inbound/nurseClaimCompareInboundDetail`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const bulkClaim = params => {
    return axios.post(`/inbound/bulkClaim`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getQtyByTracking = params => {
    return axios.post(`/common/getNumBytrackingS`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const removeImportTracking = params => {
    return axios.post(`/inbound/deleteUnClaimedTrackingImportData`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const batchRemoveImportTracking = params => {
    return axios.post(`/inbound/batchDeleteUnClaimedTrackingImportData`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};


// WEBPACK FOOTER //
// ./src/api/inboundService.js